import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

type OpenMembershipInvoice = {
    readonly id: string;
    readonly invoiceId: string;
};

type MembershipPaymentWarningProps = {
    type?: string | null;
    amount?: string | number | null;
    openInvoice?: OpenMembershipInvoice | null;
    renewalFeeGross?: string | null;
    isEdit?: boolean;
};

const FEE_TOLERANCE_CENTS = 100;

export const MembershipPaymentWarning: React.FC<MembershipPaymentWarningProps> = ({
    type,
    amount,
    openInvoice,
    renewalFeeGross,
    isEdit = false,
}) => {
    const { t } = useTranslation('documents');

    if (isEdit || (type !== 'DEPOSIT' && type !== 'CREDIT')) return null;

    // GraphQL Decimal arrives as a string
    const booked = amount === '' || amount == null ? NaN : Number(amount);
    const fee = renewalFeeGross == null ? NaN : Number(renewalFeeGross);
    const matchesFee =
        Number.isFinite(booked) &&
        Number.isFinite(fee) &&
        Math.round(Math.abs(booked - fee) * 100) <= FEE_TOLERANCE_CENTS;

    if (!openInvoice && !matchesFee) return null;

    // The invoice number inside the sentence is the link to the invoice
    const openInvoiceText = openInvoice
        ? t('membershipPaymentWarningOpenInvoice', { number: openInvoice.invoiceId })
        : '';
    const numberAt = openInvoice ? openInvoiceText.indexOf(openInvoice.invoiceId) : -1;

    return (
        <div
            role="alert"
            className="flex flex-col gap-1 rounded border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900"
        >
            {openInvoice && (
                <div>
                    {openInvoiceText.slice(0, numberAt)}
                    <Link to={`/invoices/${openInvoice.id}`} className="underline font-medium">
                        {openInvoice.invoiceId}
                    </Link>
                    {openInvoiceText.slice(numberAt + openInvoice.invoiceId.length)}
                </div>
            )}
            {matchesFee && <div>{t('membershipPaymentWarningFeeAmount')}</div>}
        </div>
    );
};
